import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges } from '@angular/core';
import { Icon, SvgCacheService } from './svg-cache.service';

@Component({
  standalone: true,
  selector: 'ui-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnChanges {
  /**
   * The name of the icon to display
   */
  @Input({ required: true }) icon!: Icon;

  /**
   * Additional CSS classes to apply to the icon
   */
  @Input() classes?: string;

  /**
   * The size of the icon in pixels
   */
  @Input() size = 20;

  constructor(
    private svgCacheService: SvgCacheService,
    private element: ElementRef<HTMLElement>
  ) {}

  ngOnChanges() {
    this.buildSvg();
  }

  private buildSvg() {
    const icon = this.getNormalizedIcon(this.icon);

    if (!icon) {
      return;
    }

    try {
      // Set the innerHTML of the element to the SVG string
      this.element.nativeElement.innerHTML = icon;
      // Select the svg element and add classes and styles
      const svg = this.element.nativeElement.querySelector('svg');
      if (!svg) {
        return;
      }

      // Add data-testid for testing
      svg.setAttribute('data-testid', this.icon);
      svg.classList.add(...(this.classes?.split(' ') ?? []));
      svg.style.setProperty('min-width', `${this.size}px`);
      svg.style.setProperty('height', `${this.size}px`);
      svg.style.setProperty('width', `${this.size}px`);
    } catch {
      // Do nothing
    }
  }

  private getNormalizedIcon(iconName: Icon): string {
    let icon = this.svgCacheService.getIcon(iconName);
    if (iconName.includes('griddy') && !icon.includes('viewBox')) {
      icon = icon.replace('<svg', '<svg viewBox="0 0 24 24"');
    }
    return icon;
  }
}
